import axios from "axios";

// const request = async (metodo, url, data = null) => {
const request = async (metodo, url, data = null, extraConfig = {}) => {
  const token = localStorage.getItem("tokenSurvey");

  try {
    const response = await axios({
      method: metodo,
      url: `${process.env.REACT_APP_API_URL}${url}`,
      data,
      headers: token ? {
        Authorization: `Bearer ${token}`,
      } : {},
      validateStatus: status => status < 500,
      ...extraConfig,
    });

    if (response.status === 401) {
      console.log("Token existe pero no es válido");
      localStorage.removeItem("tokenSurvey");
      window.location.href = "/login";
      return {
        peticion: response.data,
        error: true,
        status: 401,
        mensaje: response.data?.message,
      };
    }

    // return { peticion: response.data, error: false };

    // 👇 añade control de errores 4xx
    if (response.status >= 400) {
      return {
        peticion: response.data,
        error: true,
        status: response.status,
        mensaje: response.data?.message,
        errors: response.data?.errors, // 👈 CLAVE
      };
    }

    return { peticion: response.data, error: false };

  } catch (err) {
    const status = err.response?.status || null;
    if (status === 401) {
      console.log("Token existe pero no es válido");
      localStorage.removeItem("tokenSurvey");
      window.location.href = "/login";
    } else {
      console.error("Error en petición:", err.message);
    }
    return {
      peticion: err.response?.data,
      error: true,
      status,
      mensaje: err.response?.data?.message || err.message,
    };
  }
};

export const peticionGet = (url) => request("get", url);
export const peticionPost = (url, data) => request("post", url, data);

// export const peticionPost = (url, data) => {
//   // 🔥 endpoints públicos sin token
//   const sinAuth = ["/demo-request"];

//   const extraConfig = sinAuth.includes(url)
//     ? { headers: {} }
//     : {};

//   return request("post", url, data, extraConfig);
// };

export const peticionPut = (url, data) => request("put", url, data);
export const peticionDelete = (url) => request("delete", url);
export const peticionGetBlob = (url) => request("get", url, null, { responseType: 'blob' }); // añadido para blobs
